var map = {
	"./tech-responsive-apache-airflow.svg": 616,
	"./tech-responsive-artificial-intelligence.svg": 530,
	"./tech-responsive-azure.svg": 617,
	"./tech-responsive-chatgpt.svg": 618,
	"./tech-responsive-copilot.svg": 619,
	"./tech-responsive-data.svg": 620,
	"./tech-responsive-excel.svg": 621,
	"./tech-responsive-git.svg": 622,
	"./tech-responsive-google-cloud.svg": 623,
	"./tech-responsive-google-sheets.svg": 624,
	"./tech-responsive-hugging-face.svg": 625,
	"./tech-responsive-jupyter.svg": 626,
	"./tech-responsive-langchain.svg": 627,
	"./tech-responsive-llama.svg": 628,
	"./tech-responsive-multiple.svg": 629,
	"./tech-responsive-powerbi.svg": 630,
	"./tech-responsive-powerpoint.svg": 631,
	"./tech-responsive-python.svg": 632,
	"./tech-responsive-r.svg": 633,
	"./tech-responsive-shell.svg": 634,
	"./tech-responsive-sql.svg": 635,
	"./tech-responsive-tableau.svg": 636,
	"./tech-responsive-theory.svg": 637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 528;